import { render, staticRenderFns } from "./RoundTrip.vue?vue&type=template&id=93124e34&scoped=true&"
import script from "./RoundTrip.vue?vue&type=script&lang=js&"
export * from "./RoundTrip.vue?vue&type=script&lang=js&"
import style0 from "./RoundTrip.vue?vue&type=style&index=0&id=93124e34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93124e34",
  null
  
)

export default component.exports